import NavBar from '../components/NavBar';
import WeatherWidget from '../components/WeatherWidget';
import { CoreNavRail } from '../components/CoreNavRail';
import { useThemeStore } from '../store/themeStore';
import { getDesignTokens } from '../utils/designTokens';

export default function WeatherPage() {
  const { isDarkMode } = useThemeStore();
  const tokens = getDesignTokens(isDarkMode);

  return (
    <div className={`h-screen ${tokens.bg.gradient} relative flex flex-col overflow-hidden pr-20 transition-colors duration-300`}>
      <NavBar className={`${tokens.card.bg} ${tokens.card.shadow} ${tokens.card.border} border`} containerClassName="px-3 py-2">
        <div className="flex items-center gap-3">
          <span className={`text-lg font-semibold ${tokens.text.primary} font-serif`}>Weather</span>
          <span className={`text-sm ${tokens.text.muted}`}>Family location weather overview</span>
        </div>
      </NavBar>

      <div className="flex-1 overflow-auto pt-0 px-4 pb-4">
        <div className={`max-w-4xl mx-auto ${tokens.card.bg} ${tokens.card.border} border rounded-landing ${tokens.card.shadow} p-4`}>
          <WeatherWidget isDarkMode={isDarkMode} location="family" variant="large" />
        </div>
      </div>

      <CoreNavRail active="weather" />
    </div>
  );
}
